import React, {Component} from 'react';
import FaArrowCircleRight from 'react-icons/lib/fa/arrow-circle-right';
import FaArrowCircleLeft from 'react-icons/lib/fa/arrow-circle-left';
import styled from 'styled-components';
import {BodyContainer} from "../Container/Container";
import Slider from 'react-slick';
import {CardTitle, P2} from "../Kit/Kit";
import {AnchorPoint} from "./OurStory";

const StyledContainer = BodyContainer.extend`
  background-size: cover;
  padding-bottom: 100px;
  display: flex;
  flex-direction: column;
  
  @media(max-width: 9000px){
    padding-top: 0;
  }
  
  h3 {
  color: white;
  }
  
  .slick-dots {
    bottom: -50px;
  }
  
  .slick-dots .slick-active div{
    background: #fff;
  }
  
   @media(min-width: 768px) {
    padding-bottom: 100px;
  }
   @media(min-width: 992px) {
    padding-bottom: 150px;
  }
  
  @media(min-width: 1200px) {
    padding-bottom: 200px;
  }
`;

const StoryContainer = styled.div`
  display: grid !important;
  position: relative;
  flex-direction: column;
  grid-template-columns: 1fr;
  grid-template-rows: 300px 400px;
  
  @media(min-width: 992px) {
    flex-direction: row;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 650px;
  }
  
  @media(min-width: 1200px) {
    grid-template-rows: 725px;
  }
  
 `;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 25px 30px;
  background: #fff;
  order: 2;
  overflow: auto;
  svg{
    display: none;
  }
  
  @media(min-width: 992px) {
    order: 1;
    padding: 45px 60px;
    
    svg {
      display: initial;
      position:absolute;
      bottom: 1%;
      left: 1%;
      cursor: pointer;
    }
  }
`;

const ImgContainer = styled.figure`
  order: 1;
  position: relative;
  svg {
    display: none;
  }
  
  @media(min-width: 992px) {
    order: 2;
    
    svg {
        display: initial;
        position: absolute;
        bottom: 1%;
        right: 1%;
        cursor: pointer;
    }
  }
  
`;

const StoryImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;

const StoryText = styled.div`
 
  p{
    text-align: left;
    font-family: Cabin, sans-serif;
    color: #737373;
    //font-size: 14px;
    line-height: 1.5;
    z-index: 1;
  
    margin-bottom: 20px;
    
    //@media(min-width: 768px) {
    //  margin-bottom: 40px;
    //}
  }

  @media(min-width: 992px){
    text-align: left;
  }
`;

const StoryTitle = CardTitle.extend`
  margin-bottom: 16px;
  
  @media(min-width: 992px){
    text-align: left;
  }
`;

const Circle = styled.div`
  border: 1px solid #fff;
  border-radius: 50%;
  background: transparent;
  width: 20px;
  height: 20px;
`;

const ArrowContainer = styled.div`
  position: absolute;
  bottom: 1%;
  //display: flex;
  //justify-content: space-around;
  width: 100%;
  
  svg {
    bottom: 5px;
  }
  
  svg:first-child {
    position: absolute;
    left: 5px;
  }
  
  svg:last-child {
    position: absolute;
    right: 15px;
  }
  
  @media(min-width: 992px){
    display: none;
  }
`;

class MrNgoStory extends Component {

    next() {
        this.slider.slickNext()
    }

    previous() {
        this.slider.slickPrev()
    }

    render() {
        const settings = {
            dots: true,
            infinite: false,
            customPaging: (i) => {
                return <a><Circle/></a>
            },
            arrows: false,
        };
        const {data, bgImage} = this.props;
        const {background_image} = bgImage.edges[0].node.acf;
        return (
          <StyledContainer
            style={{background: `url(${background_image.source_url}) no-repeat bottom`}}
          >
              <AnchorPoint id={'mrngosstory'}/>
              <Slider
                ref={c => this.slider = c}
                {...settings}
              >
                  {data.map(i => {
                      return (
                        <StoryContainer>
                            <TextContainer>
                                <StoryTitle
                                  dangerouslySetInnerHTML={{__html: i.title}}
                                />
                                <StoryText>
                                    <P2
                                      dangerouslySetInnerHTML={{__html: i.story_text}}
                                    />
                                </StoryText>
                                <FaArrowCircleLeft
                                  onClick={() => this.previous()}
                                  size={30}
                                  color='black'
                                />
                            </TextContainer>
                            <ImgContainer>
                                <StoryImg src={i.source_url} alt={i.alt_text}/>
                                <FaArrowCircleRight
                                  onClick={() => this.next()}
                                  size={30}
                                  color='black'
                                />
                            </ImgContainer>
                            <ArrowContainer className="mobileArrowContainer">
                                <FaArrowCircleLeft
                                  onClick={() => this.previous()}
                                  size={20}
                                  color='black'
                                />
                                <FaArrowCircleRight
                                  onClick={() => this.next()}
                                  size={20}
                                  color='black'
                                />
                            </ArrowContainer>
                        </StoryContainer>
                      )
                  })}
              </Slider>
          </StyledContainer>
        );
    }
}

export default MrNgoStory;


// WEBPACK FOOTER //
// ./src/components/GetToKnow/MrNgoStory.js